var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F15A22",
    d: "M17.5 0C27.177 0 35 7.824 35 17.5S27.177 35 17.5 35 0 27.177 0 17.5 7.824 0 17.5 0m0 32.941A15.42 15.42 0 0 0 32.941 17.5 15.42 15.42 0 0 0 17.5 2.059 15.42 15.42 0 0 0 2.059 17.5 15.42 15.42 0 0 0 17.5 32.941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15A22",
    d: "m8.956 15.75 8.544 8.544 8.544-8.544 1.441 1.441-9.985 9.986-9.985-9.986z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15A22",
    d: "M18.53 25.735h-2.06v-17.5h2.06z"
  })));
};
export default SvgArrowUp;